import * as React from "react";
import {observer} from "mobx-react";
import {UIState} from "data/UIState";
import {ISentEmail} from "data/hr/HREmailData";
import {Helpers} from "data/hr/Helpers";
import {useState} from "react";
import {HRToolCard} from "components/hr/widgets/HRToolCard";
import {HRSmallIconButton} from "components/hr/widgets/HRSmallIconButton";

import './HREmailHistory.pcss';

export const HREmailHistory = observer(() => {

  const [email, setEmail] = useState<ISentEmail|null>(null);

  if(!UIState.emailData.initialized) {
    return null;
  }

  if(email) {
    return (
        <div className={"hr-email-detail"}>
          <div className={'nav-back'}>
            <HRSmallIconButton icon={"chevron_left"} onClick={()=>{ setEmail(null);  }} buttonText={"Back to list"}/>
          </div>

          <HRToolCard title={email.subject}>
              <h3 className={'level3'}>{Helpers.dateAndTime(email.dateSent)}</h3>
              <div><div dangerouslySetInnerHTML={{__html: email.body}}></div></div>
              <h3 className={'level3'}>recipients</h3>
              <ul>
                {email.recipients.map(r=><li>{r.email}{r.name?" ("+r.name+")":""}</li>)}
              </ul>
          </HRToolCard>
        </div>
    );
  } else {
    return (
      <div className={"hr-email-history"}>
        <HRToolCard title={"Email History"}>
          <p>All dates {UIState.settings.DEPLOYMENT_TIMEZONE}</p>
          <table>
            <thead>
            <tr>
              <th>Date Sent</th>
              <th>Subject</th>
              <th>Recipients</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
              {UIState.emailData.sentEmails.map((email)=><SentEmailRow key={email._id} email={email} onClick={setEmail}/>)}
            </tbody>
          </table>
        </HRToolCard>
      </div>
    );
  }

});


const SentEmailRow = (props:{ email:ISentEmail, onClick:(email:ISentEmail)=>void} ) =>
  <tr>
    <td>{Helpers.dateAndTime(props.email.dateSent)}</td>
    <td>{props.email.subject}</td>
    <td>{props.email.recipients.length}</td>
    <td><HRSmallIconButton icon={"chevron_right"} onClick={()=>{ props.onClick(props.email);  }}/></td>
  </tr>
;